var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimelineIconThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 8.83301H13.3332C14.3457 8.83301 15.1665 9.65382 15.1665 10.6663V12.6663C15.1665 13.6789 14.3457 14.4997 13.3332 14.4997H9.99984C8.98732 14.4997 8.1665 13.6789 8.1665 12.6663V10.6663C8.1665 9.65382 8.98732 8.83301 9.99984 8.83301ZM13.3332 9.83301H9.99984C9.5396 9.83301 9.1665 10.2061 9.1665 10.6663V12.6663C9.1665 13.1266 9.5396 13.4997 9.99984 13.4997H13.3332C13.7934 13.4997 14.1665 13.1266 14.1665 12.6663V10.6663C14.1665 10.2061 13.7934 9.83301 13.3332 9.83301Z",
    fill: "#323232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6665 10.833C14.9426 10.833 15.1665 11.0569 15.1665 11.333C15.1665 11.5861 14.9784 11.7953 14.7344 11.8284L14.6665 11.833H8.6665C8.39036 11.833 8.1665 11.6092 8.1665 11.333C8.1665 11.0799 8.35461 10.8707 8.59866 10.8376L8.6665 10.833H14.6665Z",
    fill: "#653494",
    stroke: "#653494",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 1.5C13.0337 1.5 14.421 2.84009 14.4967 4.52171L14.5 4.66667V6.66667C14.5 6.94281 14.2761 7.16667 14 7.16667C13.7469 7.16667 13.5377 6.97856 13.5046 6.73451L13.5 6.66667V4.66667C13.5 3.51131 12.5957 2.56717 11.4563 2.50343L11.3333 2.5H4.66667C3.51131 2.5 2.56717 3.4043 2.50343 4.54372L2.5 4.66667V9.33333C2.5 10.4887 3.4043 11.4328 4.54372 11.4966L4.66667 11.5H6C6.27614 11.5 6.5 11.7239 6.5 12C6.5 12.2531 6.3119 12.4623 6.06785 12.4954L6 12.5H4.66667C2.96635 12.5 1.57902 11.1599 1.50326 9.47829L1.5 9.33333V4.66667C1.5 2.96635 2.84009 1.57902 4.52171 1.50326L4.66667 1.5H11.3333Z",
    fill: "#653494",
    stroke: "#653494",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.20802 4.80093C4.30887 4.56875 4.56474 4.45182 4.80178 4.51868L4.86583 4.54152L7.69032 5.76836C7.86031 5.84247 8.05013 5.85332 8.22634 5.80067L8.31315 5.76905L11.1355 4.55327C11.3891 4.44403 11.6833 4.56106 11.7925 4.81467C11.8926 5.04715 11.8027 5.31369 11.5916 5.44065L11.5311 5.47169L8.70939 6.6872C8.29774 6.86517 7.83576 6.8807 7.41589 6.73413L7.29129 6.68529L4.46743 5.45873C4.21415 5.34872 4.09801 5.05421 4.20802 4.80093Z",
    fill: "#653494",
    stroke: "#653494",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineIconThree);
export default __webpack_public_path__ + "static/media/timeline-icon-three.be39eb5507278e2c373fbb0f5d3746ef.svg";
export { ForwardRef as ReactComponent };